// extracted by mini-css-extract-plugin
module.exports = {"unique-owners-list":"UniqueOwnersModal_unique-owners-list__3GW3N"};